import { render, staticRenderFns } from "./CouponPubStatus.vue?vue&type=template&id=ca06ef5e&"
import script from "./CouponPubStatus.vue?vue&type=script&lang=js&"
export * from "./CouponPubStatus.vue?vue&type=script&lang=js&"
import style0 from "./CouponPubStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports